$(document).ready((function() {
    var e, t;

    function a() {
        windowWidth = $(window).innerWidth(), e = windowWidth <= 1024
    }

    function s() {
        $("body").removeClass("open-flyout-nav open-panel-2 open-panel-3 open-panel-4 open-cart open-search open-login"), $(".js-nav-panel").attr("aria-expanded", "false"), $(".nav-link--active").removeClass("nav-link--active"), $(".nav-animate-in").removeClass("nav-animate-in"), o(), $(".js-open-nav-section .js-close-icon-text").hide(), $(".js-open-nav-section .js-open-icon-text").fadeIn(350)
    }

    function o() {
        $(".js-panel-level-4").attr("aria-expanded", "false"), $(".js-shoppable-inner:visible .product .inner").removeClass("nav-animate-in")
    }

    function n(e) {
        setTimeout((function() {
            e.each((function(e) {
                var t = this;
                setTimeout((function() {
                    $(t).addClass("nav-animate-in")
                }), 90 * e)
            }))
        }), 50)
    }

    function i(e, t) {
        var a = $(e),
            s = $(e).data("related-submenu"),
            o = ($(e).data("collection"), setTimeout((function() {
                $(".js-submenu").hide(), $(".js-submenu").attr("aria-expanded", "false"), $(".js-submenu .active").removeClass("active"), $(".js-submenu .nav-animate-in").removeClass("nav-animate-in");
                var e = $('[data-submenu="' + s + '"]');
                $(".js-panel-level-3").attr("aria-expanded", "true"), e.show(), $("body").addClass("open-panel-3"), n(e.find("a")), setTimeout((function() {
                    0 == $('[data-submenu="' + s + '"] .active').length && e.find("li:first-of-type a").addClass("active")
                }), 450)
            }), 100));
        a.mouseleave((function() {
            clearTimeout(o)
        }))
    }

    function r(e) {
        var a = $(e),
            s = $(e).data("collection"),
            o = $('.js-shoppable-inner [data-subnav-collection="' + s + '"]'),
            i = setTimeout((function() {
                $(".js-filter-submenu.active").removeClass("active"), a.addClass("active"), $(".js-shoppable-inner:visible"),
                    function(e, a, s, o) {
                        var i = $(a).find(".product");
                        t && t.includes("hair") ? $(".nav-featured-link").show() : $(".nav-featured-link").hide(), $(".js-panel-level-4").attr("aria-expanded", "true"), $("body").addClass("open-panel-4"), $(".js-shoppable-inner .product").removeClass("nav-animate-in"), $(".js-shoppable-subnav").hide(), $(".js-shoppable-inner .product").hide(), $(a).show(), $(a).find(".product").show(), $(a).find(".product img").show(), $(".js-panel-level-4 .scrollable, .js-shoppable-inner").scrollTop(0), $(o).closest(".js-nav-panel").find("a").removeClass("nav-item--active"), $(o).addClass("nav-item--active"), n($(i))
                    }(0, o, 0, e)
            }), 25);
        a.mouseleave((function() {
            clearTimeout(i)
        }))
    }
    console.log("Shopify Development - Sarah Holden"), console.log("https://saraheholden.com/"), console.log(" "), console.log("Site Design - AndCompany"), console.log("https://www.andcompany.com/"), $(window).on("resize", a), a(), setTimeout((function() {
        $(".hamburger").addClass("loaded")
    }), 3e3), document.addEventListener("smartrr:bundleAdded", (function(e) {
        $("body").removeClass("open-flyout-nav open-panel-2 open-panel-3 open-panel-4"), $(".js-nav-panel").attr("aria-expanded", "false"), $(".nav-link--active").removeClass("nav-link--active"), $(".nav-animate-in").removeClass("nav-animate-in"), o(), $(".js-open-nav-section .js-close-icon-text").hide(), $(".js-open-nav-section .js-open-icon-text").fadeIn(350)
    })), $(".hamburger").on("click", (function(e) {
        e.preventDefault(), $("body").hasClass("open-panel-2") ? s() : (s(), $(".nav-animate-in").removeClass("nav-animate-in"), $("body").addClass("open-flyout-nav open-panel-2"), $(".js-panel-level-2").attr("aria-expanded", !0), $(".js-panel-level-2").focus(), n($(".js-panel-level-2 a")), $.each($(".js-nav-lazy-load"), (function(e, t) {
            var a = $(this).data("nav-src");
            $(this).attr("src", a)
        })))
    })), $(".js-close-flyout").on("click", (function() {
        s()
    })), $(".js-close-panel-level-4").on("click", (function() {
        $(".js-panel-level-4").attr("aria-expanded", "false"), $("body").removeClass("open-panel-4")
    })), $(".js-close-panel-level-3").on("click", (function() {
        $(".js-panel-level-3").attr("aria-expanded", "false"), $("body").removeClass("open-panel-3")
    }));
    const l = window.matchMedia("(max-width: 1024px)");

    function c(e) {
        e.matches ? ($("[data-related-submenu]").off("mouseenter", d), $(".js-panel-level-2, .js-panel-level-2 .childless ").off("mouseenter", p), $(".js-filter-submenu").off("mouseover", u)) : ($("[data-related-submenu]").on("mouseenter", d), $(".js-panel-level-2, .js-panel-level-2 .childless ").on("mouseenter", p), $(".js-filter-submenu").on("mouseover", u))
    }

    function d(e) {
        i(this), t = $(this).text() && $(this).text().trim().toLowerCase(), $(this).closest(".js-nav-panel").find("a").removeClass("nav-item--active"), $(this).addClass("nav-item--active")
    }

    function p() {
        $(".js-panel-level-3").attr("aria-expanded", "false"), $(".js-panel-level-3 .nav-animate-in").removeClass("nav-animate-in"), $("body").removeClass("open-panel-3 open-panel-4"), o()
    }

    function u() {
        r(this)
    }
    var m, f;

    function v() {
        $(window).scrollTop() > 80 ? $("body").addClass("scrolled") : $("body").removeClass("scrolled")
    }

    function h(e, t, a) {
        var s = gsap.timeline({
            scrollTrigger: {
                trigger: a,
                start: t
            }
        });
        const o = new SplitText(a, {
                type: "lines",
                linesClass: "split-line-child"
            }),
            n = new SplitText(a, {
                type: "lines",
                linesClass: "split-line-wrap-++"
            });
        s.staggerFrom($(a).find(".split-line-child"), 1.2, {
            y: "100%",
            ease: Power3.easeOut,
            delay: e
        }, .15).add((function() {
            n.revert(), o.revert()
        }))
    }
    if (c(l), l.addListener(c), $("[data-related-submenu]").on("click", (function(t) {
            if (e) {
                var a = $(this),
                    s = "true" == a.attr("data-tapped");
                s && clearTimeout(m), s || (t.preventDefault(), a.attr("data-tapped", "true"), m = setTimeout((function() {
                    i(a), a.attr("data-tapped", "false")
                }), 200))
            }
        })), $(".js-filter-submenu").on("click", (function(t) {
            if (e) {
                var a = $(this),
                    s = "true" == a.attr("data-tapped");
                s && clearTimeout(f), s || (t.preventDefault(), a.attr("data-tapped", "true"), f = setTimeout((function() {
                    r(a), a.attr("data-tapped", "false")
                }), 200))
            }
        })), $(".js-open-nav-section").on("click", (function(e) {
            e.preventDefault();
            var t = $(this).data("nav-section"),
                a = $(this);
            $("body").hasClass(`open-${t}`) ? s() : $("body").hasClass("open-flyout-nav") ? (s(), setTimeout((function() {
                a.find(".js-open-icon-text").hide(), a.find(".js-close-icon-text").fadeIn(350), $("body").addClass(`open-${t} open-flyout-nav`), "search" == t && $(".js-search").focus()
            }), 400)) : (a.find(".js-open-icon-text").hide(), a.find(".js-close-icon-text").fadeIn(350), $("body").addClass(`open-${t} open-flyout-nav`), "search" == t && setTimeout((function() {
                $(".js-search").focus()
            }), 200))
        })), gsap.registerPlugin(ScrollTrigger), ScrollTrigger.defaults({
            markers: !1
        }), ScrollTrigger.matchMedia({
            "(min-width: 1024px)": function() {
                gsap.utils.toArray("[data-from]").forEach(((e, t) => {
                    const a = JSON.parse(e.dataset.from),
                        s = JSON.parse(e.dataset.to),
                        o = e.dataset.start ? e.dataset.start : "top bottom",
                        n = e.dataset.end ? e.dataset.end : "bottom top";
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: e,
                            scrub: !0,
                            start: o,
                            end: n
                        }
                    }).fromTo(e, a, s)
                }))
            },
            "(max-width: 1024px)": function() {
                gsap.utils.toArray("[data-mobile-from]").forEach(((e, t) => {
                    const a = JSON.parse(e.dataset.mobileFrom),
                        s = JSON.parse(e.dataset.mobileTo),
                        o = e.dataset.start ? e.dataset.start : "top bottom",
                        n = e.dataset.end ? e.dataset.end : "bottom top";
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: e,
                            scrub: !0,
                            start: o,
                            end: n
                        }
                    }).fromTo(e, a, s)
                }))
            }
        }), gsap.utils.toArray(".scroll-enter").forEach(((e, t) => {
            const a = e.dataset.delay ? e.dataset.delay : 0;
            gsap.timeline({
                scrollTrigger: {
                    trigger: e,
                    start: "center bottom"
                }
            }).fromTo(e, 1.2, {
                autoAlpha: 0,
                y: 20
            }, {
                autoAlpha: 1,
                y: 0,
                ease: Power4.easeOut,
                delay: a
            })
        })), gsap.utils.toArray(".js-animate").forEach(((e, t) => {
            ScrollTrigger.create({
                trigger: e,
                start: "top 80%",
                onEnter: t => $(e).addClass("animate-in")
            })
        })), $(".js-animate-on-load").addClass("animate-in"), v(), $(window).on("scroll", (function() {
            v()
        })), $(".js-update-bg").length > 0 && gsap.utils.toArray(".js-update-bg").forEach(((e, t) => {
            ScrollTrigger.create({
                trigger: ".js-update-bg",
                start: "top 45%",
                end: "bottom center",
                onEnter: t => $("body").css("background-color", $(e).attr("data-color")),
                onLeave: e => $("body").css("background-color", "#F3F3F4"),
                onEnterBack: t => $("body").css("background-color", $(e).attr("data-color")),
                onLeaveBack: e => $("body").css("background-color", "#F3F3F4")
            })
        })), ScrollTrigger.batch("[data-stagger]", {
            onEnter: e => gsap.to(e, 1.2, {
                autoAlpha: 1,
                y: 0,
                stagger: .15,
                ease: Power1.easeOut
            }),
            start: "40px bottom"
        }), document.fonts.ready.then((function() {
            $('[data-reveal="lines-masked"]').addClass("loaded"), $('[data-reveal="lines-masked-delayed"]').addClass("loaded"), $('[data-reveal="lines-masked-slow"]').addClass("loaded"), $('[data-reveal="lines-masked-desc"]').addClass("loaded"), $('[data-reveal="words-masked"]').addClass("loaded"), gsap.utils.toArray('[data-reveal="lines-masked-slow"]').forEach(((e, t) => {
                var a = gsap.timeline({
                    scrollTrigger: {
                        trigger: e,
                        start: "center bottom"
                    }
                });
                const s = new SplitText(e, {
                        type: "lines",
                        linesClass: "split-line-child"
                    }),
                    o = new SplitText(e, {
                        type: "lines",
                        linesClass: "split-line-wrap-++"
                    });
                a.staggerFrom($(e).find(".split-line-child"), 1.6, {
                    y: "100%",
                    ease: Power3.easeOut
                }, .3).add((function() {
                    o.revert(), s.revert()
                }))
            })), gsap.utils.toArray('[data-reveal="lines-masked"]').forEach(((e, t) => {
                h(e.dataset.delay ? e.dataset.delay : 0, e.dataset.start ? e.dataset.start : "center bottom", e)
            })), gsap.utils.toArray('[data-reveal="lines-masked-delayed"]').forEach(((t, a) => {
                let s = t.dataset.delay ? t.dataset.delay : 0;
                e && (s = t.dataset.delay ? t.dataset.delay - .6 : 0), h(s, t.dataset.start ? t.dataset.start : "center bottom", t)
            })), gsap.utils.toArray('[data-reveal="lines-masked-desc"]').forEach(((e, t) => {
                h(e.dataset.delay ? e.dataset.delay : 0, e.dataset.start ? e.dataset.start : "center bottom", $(e).find("p"))
            })), gsap.utils.toArray('[data-reveal="words-masked"]').forEach(((e, t) => {
                const a = e.dataset.start ? e.dataset.start : "top 80%";
                var s = gsap.timeline({
                        scrollTrigger: {
                            trigger: e,
                            start: a
                        }
                    }),
                    o = new SplitText($(e).find(".animate-me"), {
                        type: "lines,words",
                        linesClass: "split-line-wrap",
                        wordsClass: "split-line-child"
                    });
                s.staggerFrom($(e).find(".split-line-child"), 1.4, {
                    y: "100%",
                    skewX: -15,
                    rotate: 2,
                    ease: Power4.easeOut
                }, .1), $(window).resize((function() {
                    s.progress(1), o.revert()
                }))
            })), gsap.utils.toArray('[data-reveal="blocks-slide"]').forEach(((e, t) => {
                const a = e.dataset.start ? e.dataset.start : "top 80%";
                gsap.timeline({
                    scrollTrigger: {
                        trigger: e,
                        start: a
                    }
                }).staggerFromTo($(e).find(".animate-me"), 1.4, {
                    y: "200px",
                    autoAlpha: 0,
                    ease: Power4.easeOut
                }, {
                    y: "0",
                    autoAlpha: 1,
                    ease: Power4.easeOut
                }, .1)
            }))
        })), $(".scaling-mask").length > 0 && ScrollTrigger.matchMedia({
            "(max-width: 1024px) and (min-width: 768px)": function() {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-intro",
                        scrub: !0,
                        start: "100px center",
                        end: "bottom center"
                    }
                }).fromTo(".scaling-mask", 1, {
                    clipPath: "inset(7rem 16rem 12rem 16rem)"
                }, {
                    clipPath: "inset(0px 0px 0px 0px)",
                    ease: Power1.easeIn
                })
            },
            
            "(min-width: 1025px)": function() {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-intro",
                        scrub: !0,
                        start: "100px center",
                        end: "bottom center"
                    }
                }).fromTo(".scaling-mask", 1, {
                    clipPath: "inset(12rem 25rem 12rem 25rem)"
                }, {
                    clipPath: "inset(0px 0px 0px 0px)",
                    ease: Power1.easeIn
                })
            }
        }),  $(".template-product").length > 0) {
      
    }


  


}));